import 'regenerator-runtime/runtime';
import {MobiusClient} from "@mobiusjs/homme-site-client";

const isLocal = window.currentState.routes.local

const client = MobiusClient(__dirname)
let config = require('../config' + (isLocal ? ".local" : "")).default
config.theme = require('./config' + (isLocal ? ".local" : "")).default
client.setConfig(config);
client.run()

